/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from 'utils/styles/style_helpers';


// ********* HELPERS ********* //
const questionPropertiesThinStyles = {
	'& .questionformatselector': {
		fontSize: '70%',
		justifyContent: 'space-around',
	}
};
const questionPropertiesThinnestStyles = {
	'& .questionformatselector': {
		justifyContent: 'space-around',
	}
};


/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// QUESTION PROPERTIES : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	questionproperties: {
		'& .questioncontainer': {		
			'& .questionformatselector': {
				display: 'flex',
				flexWrap: 'wrap',
				justifyContent: 'space-between',
				alignItems: 'center'
			},
			'& .questiontitle': {
				marginBottom: pxToEm(2),
			},
		},
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.customizeThinnest]: {
		questionproperties: {
			extend: questionPropertiesThinnestStyles
		}
	},
	[mediaQuery.customizeRailThin]: {
		questionproperties: {
			'&.rail': { extend: questionPropertiesThinStyles }
		}
	},
	[mediaQuery.customizeInContentThin]: {
		questionproperties: {
			'&.incontent': { extend: questionPropertiesThinStyles }
		}
	}
});